import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

  :host .bu-title-5 {
    margin-top: 16px;
    margin-bottom: 16px;
  }

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

header button {
    margin-left: auto;
  }

.section-table-header {
  display: flex;
  padding: 8px 16px;
  font-size: var(--font-size-sm);
  font-weight: 700;
  border-bottom: 1px solid var(--light);
}

@media (max-width: 767px) {

.section-table-header {
    display: none
}
  }

.section-table-header div + div {
      margin-left: 16px;
    }

.section-table-header div:first-child {
      flex: 1;
    }

.section-table-header div:not(:first-child) {
      flex-basis: 100px;
      color: var(--dark-text-secondary);
    }

.section-table-header div:last-child {
      flex-basis: 50px;
    }

.level-top slot[name='folders-title'] {
  display: none;
}

:host([layout='list']) .level-top slot[name='folders']::slotted(*:not(:last-of-type)),
    :host([layout='list']) .level-top slot[name='files']::slotted(*:not(:last-of-type)) {
      margin-bottom: 16px;
    }

@media (max-width: 767px) {
      :host([layout='list']) .level-inner slot[name='folders']::slotted(*:not(:last-of-type)),
      :host([layout='list']) .level-inner slot[name='files']::slotted(*:not(:last-of-type)) {
        margin-bottom: 16px;
      }
    }

@media (min-width: 768px) {
      :host([layout='list']) .level-inner slot[name='folders']::slotted(*),
      :host([layout='list']) .level-inner slot[name='files']::slotted(*) {
        border-bottom: 1px solid var(--light);
      }
    }
`;
export default styles;
